<template>
  <div class="animated fadeIn">
    <b-card>
      <template slot="header"><i class='fa fa-align-justify'></i>Result History</template>
      <!-- detail search start -->
      <!--
        상세 점검 내용
        1. 점검 시작 시간 - 적용됨
        2. 점검 종료 시간 - 적용됨
        3. 점검 총 시간
        4. 탐지 여부 - 적용됨
        5. 에러 여부 - 적용됨
        6. 페이지 여부 - ??
       -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Inspection Date
                <b-button size="sm" variant="info" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_visit"> Finished Date
                <b-button size="sm" variant="info" @click="set_sd('', 'finished_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'finished_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'finished_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'finished_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'finished_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'finished_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.finished_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.finished_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-form-group>
              <label for="opt_error">Error</label><br>
              <c-switch v-if="so.adv" v-model="so.opt.error_count" @change="($event) = so.opt = Object.assign({}, so.opt, { error_count : $event }); refresh()"  color="warning" label variant="pill" />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label for="opt_error">Detect</label><br>
              <c-switch v-if="so.adv" v-model="so.opt.detect_count" @change="($event) = so.opt = Object.assign({}, so.opt, { detect_count : $event }); refresh()"  color="danger" label variant="pill" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group v-model="so.opt.match_type" @change="($event) = so.opt = Object.assign({}, so.opt, { match_type : $event })" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->

      <b-card>
        <b-row>
          <b-col md="5">
            <span class="text-center" v-b-tooltip.hover title="can see the log real-time">
              Show Count
              <select v-model="so.perPage" @change="refresh">
                <option disabled value="15">Default 15</option>
                <option value=10>10</option>
                <option value=50>50</option>
                <option value=100>100</option>
              </select>
            </span>
          </b-col>
          <b-col sm="5">
            <!-- 여기서 고민되는 부분이 점검 결과에서 어떠한 페이지를 검색 할 것인가임 -->
            <!--
              내가 만약 사용자라면 점검하고 싶은 부분
              1. 점검 실패한 부분이나 탐지된 경우
              2. 특정 페이지 범위
            -->
            <b-input-group size="sm" class="pr-3">
              <b-input-group-append>
                <label class="mr-3" for="opt_detect">Quick Search</label>
              </b-input-group-append>
              <b-input-group-append>
                <label class="mr-3" for="opt_detect">Detect</label>
                <c-switch class="mr-3" :disabled="so.adv"  color="danger" label variant="pill" @change="($event) => { if(loading) { return; } so.sv = $event; so.sk = 'detect_count'; refresh() }" />
              </b-input-group-append>

              <b-input-group-append>
                <label class="mr-3" for="opt_error">Error</label>
                <c-switch class="mr-3" :disabled="so.adv"  color="warning" label variant="pill" @change="($event) => { if(loading) { return; } so.sv = $event; so.sk = 'error_count'; refresh() }"  />
              </b-input-group-append>
            </b-input-group>

          </b-col>
          <b-col sm="1">
            <b-btn block variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
          </b-col>
          <b-col sm="1">
            <b-btn block variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
          </b-col>
        </b-row>
        <hr>
        * <b-badge variant="primary">Ticket </b-badge>
        : You can copy tickets by pressing FQDN. If there is a problem with the site, you must contact with the ticket to process it quickly.
        <br>
        * <b-badge variant="success">Safety </b-badge>
        : No malicious code distribution and waypoint detected
        <br>
        * <b-badge variant="danger">Detect </b-badge>
        : There is a detected malicious code distribution and waypoint
        <br>
        * <b-badge variant="warning">Error</b-badge>
        : This is a case where the page failed to the load normally. Pages response status : <a target="_blank" href="https://en.wikipedia.org/wiki/List_of_HTTP_status_codes">400 ~ 500</a>
        <br>
        * <b-badge variant="dark">Inspection Failed</b-badge>
        : Failure to check from the first page of the check or a problem with the system.
        <hr>
        <b-table hover striped small responsive="sm" ref="_list" show-empty empty-text="not found"
          :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
          <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
          <template slot="fqdn" slot-scope="row">
            <b-img v-bind="{ width: 15, height: 15 }"  src="ico/copy.ico" alt=""></b-img>
            <b-button variant="link" @click="copy(row.item.task_key, site.fqdn)">
              {{site.fqdn}}
            </b-button>
            <b-button variant="link" :href="'http://'+site.fqdn" target="_blank">
              <i class="fa fa-share"></i>
            </b-button>

          </template>
          <template slot="count" slot-scope="row">
            {{row.item.page_count || 0}} / {{row.item.ext_count || 0}} / {{row.item.resource_count || 0}}
          </template>
          <template slot="created_at" slot-scope="row">
            {{row.item.started_at | utcdatetime}} ~ {{row.item.finished_at | utcdatetime}}
          </template>
          <template slot="status" slot-scope="row">
            <b-badge v-if="row.item.detect_count > 0" variant="danger">Detect <b-badge variant="light">{{row.item.detect_count}}</b-badge></b-badge>
            <b-badge v-else variant="success">Safety </b-badge>
            <b-badge v-if="row.item.error_count > 0" variant="warning">Error <b-badge variant="light">{{row.item.error_count}}</b-badge></b-badge>
            <b-badge v-if="row.item.finished_at && row.item.page_count < 1" variant="dark">Inspection Failed</b-badge>

            <!-- 400 ~ 500 -->
            <!-- 에러에 대한 추가 설명 필요 -->
          </template>
          <template slot="func" slot-scope="row">
            <b-btn v-if="!row.item.finished_at" @click="sync.task_key = row.item.task_key; timer()"  size="sm" variant="primary">
              <span v-if="sync.status && row.item.task_key == sel_status.task_key" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">&nbsp;</span>
              Inspecting
            </b-btn>
            <b-btn v-else @click="detail(row.item.id)" size="sm" variant="outline-primary">More</b-btn>
            <b-btn v-if="!row.item.finished_at" @click="scan_stop(row.item.task_key)"  size="sm" variant="warning">STOP</b-btn>
          </template>
        </b-table>
        <hr>

        <b-row>
          <b-col md="6">
            <b-pagination class="pull-left" size="sm" :total-rows="getRowCount" :per-page="so.perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
          </b-col>
          <b-col md="6">
            <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>
            <!-- <b-button v-if="sel_status && sel_status.task_key" size="sm" class="float-right text-white mr-2" variant="info" @click="sync.status = !sync.status"> Auto Refresh ({{sync.timer}}) </b-button> -->
          </b-col>
        </b-row>
        <!-- 사이트 점검 정보 -->
      </b-card>
      <!-- 여기서 상세 내용  보여 줘야 함 -->
      <hr v-if="sel_result && sel_result.id && $route.params.site_id">
      <detail v-if="sel_result && sel_result.id && $route.params.site_id" :result_id="sel_result.id" :item="{ fqdn : site.fqdn }"></detail>
      <status v-if="sel_status && sel_status.task_key" :status="sel_status" :refresh_timer="sync.timer" @stop="sync.status = !sync.status"/>
    </b-card>
    <!-- <hr>
    <router-view @refresh="refresh()"></router-view> -->
  </div>
</template>

<script>
import Status from './Result.Status';
import Detail from './Result.Detail';
import custom from '@/custom';
import codes from '@/codes';
import DatePicker from 'vue2-datepicker';
import { Api } from '@/service';
import moment from 'moment-timezone'
import { Switch as cSwitch } from '@coreui/vue';
import WMDS_Agent_Call from './service'

export default {
  components: { cSwitch, DatePicker, Detail, Status },
  data: () => {
    return {
      sync : { interval : 30 * 1000, th : undefined, status : false, task_key : '', timer : 0, timer_func : undefined },
      load_count : 0,
      loading : true,
      currentPage : 1,
      so : Object.assign({}, codes.DEFAULT_OPT, { opt : {} }),
      codes,
      custom,
      site : {},
      sel_result : {},
      sel_status : {}
    }
  },
  watch : {
    currentPage() { this.load() }
  },
  computed: {
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    getRowCount () { return this.so.totalRows || 0; },
    fields : function() {
      return [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
        { key: 'fqdn', label: 'FQDN', sortable: false, thStyle: 'width: 15%' },
        { key: 'created_at', label: 'Inspected time', sortable: true },
        { key: 'count', label: 'Pages (Page / Resource / External )', sortable: false },
        { key: 'status', label: 'Result', sortable: false },
        { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%'  },
      ]
    },
  },
  methods: {
    clear() {
      try {
        clearTimeout(this.sync.th)
        this.sync.th = undefined
        clearTimeout(this.sync.timer_func)
        this.sync.timer_func = undefined

        this.sel_status = Object.assign({})
        this.sel_result = Object.assign({})

        this.refresh()

      } catch (e) { console.log(e) }
    },
    timer() {
      try {
        // console.log("timer", this.sync.timer)
        if(this.sync.timer_func) {
          clearTimeout(this.sync.timer_func)
          this.sync.timer_func = undefined
        } else { this.sync.status = true; this.result_select() }

        if(this.sync.status) {
          this.sync.timer += -1
        } else {
          clearTimeout(this.sync.th)
          this.sync.th = undefined
        }

        if(this.sync.timer < 0) {
          this.sync.timer = this.sync.interval / 1000
          this.result_select()
        }
        this.sync.timer_func = setTimeout(this.timer, 1000)
      } catch (e) { console.log(e) }
    },
    async result_select() {
      try {
        // console.log(this.sync.status, 'this.sync.status')
        if(this.sync.status) {
          let rs = await WMDS_Agent_Call.status(this.sync.task_key)

          if(!rs || rs.error) {
            this.clear()
            return this.$toastr.e("Data is not Available");
          }
          if(rs.pl.task_key != this.sync.task_key) { return console.log('not same, before request so ignore') }
          if(rs && rs.pl) { this.sel_status = Object.assign({}, this.sel_status, rs.pl) }
          // 3 은 quit 임, codes 참고
          if(this.sel_status.status == 3) { this.clear() }

        }
        this.$toastr.i("update checking info")
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) }
    },
    async scan_stop(task_key){
      try {
        // TODO : 현재 응답 값이 없음 이거는 문제임
        if(this.sync.task_key == task_key) { this.clear() }
        console.info('request scaning stop', task_key)
        let rs = await WMDS_Agent_Call.stop(task_key)
        // console.log(rs, 'result')
        this.$toastr.i('request to stop')
        this.refresh()
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
    },
    list() { this.$router.push({ name: 'wmds_result' }); this.$emit('refresh')},
    copy(task_key, fqdn) {
      try {
        var tempElem = document.createElement('textarea');
        tempElem.value =`${fqdn}|${task_key}`;
        document.body.appendChild(tempElem);
        tempElem.select();
        document.execCommand("copy");
        document.body.removeChild(tempElem);
        this.$toastr.i("ticket copied for QNA")
      } catch (e) { console.log(e); this.$toastr.i("copied failed") }
    },
    search_opt() {
      delete this.so.opt.is_alive // 통합된 부분이라서 이렇게 미사용하는 변수는 예외 처리 필요
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day");
        this.so.opt['finished_at_ed'] = moment().add(1, "day");
        this.so.opt['match_type'] = 'and';
        this.so.sv = ''
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k.endsWith('_count')) {
        return { name : k, value : 0, op :  v == true ? '>' : '<=' }
      } else if(k.endsWith('_id')) {
        return { name : k, value : Number(v), op :  '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;

      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          // case '+1d' : sd = moment(sd).subtract(-1, 'd'); break;
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt, opt);
    },
    reset() { this.so = Object.assign({}, codes.DEFAULT_OPT, { opt : {} }); this.sel_result = {}; this.refresh(); },
    refresh() { this.$refs._list && this.$refs._list.refresh(); this.sel_result = {}; this.sel_status = {} },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      this.loading = true
        this.so.currentPage = this.currentPage
        let so = {
          target : 'wmds.result', cmd : 'list',
          body : {
            sort : [{ name : "id", op : "desc" }],
            or : [],
            and : []
          },
          offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
        }

        if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
        if(this.$route.params && this.$route.params.site_id) { so.body.and.push(this.set_op('site_id', this.$route.params.site_id, so)); }

        if(this.so.adv && this.so.opt) {
          var k = Object.keys(this.so.opt)
          for (let i = 0; i < k.length; i++) {
            if(k[i] == 'match_type') { continue; }
            let cond = undefined;

            switch (k[i]) {
              case 'created_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'created_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              case 'finished_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 11), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'finished_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 11), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              default:
                cond = this.set_op(k[i], this.so.opt[k[i]]);
                break;
            }
            if(cond.value == '%%' || cond.value === '') { continue; }
            if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
            else { so.body.or.push(cond) }
          }
        } else {
          if(this.so.sk && this.so.sv != undefined) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }
        }
      return Api.Manager(so).then(rs => { this.so.totalRows = rs.total; this.$emit('loading', false); this.loading = false; return rs.body ? rs.body : []; })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    },
    load_site() {
      try {
        let so = {
          target : 'site', cmd : 'detail',
          body : {
            id : this.$route.params.site_id
          },
        }
        Api.Manager(so).then(rs => { this.site = rs.body })
          .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
      } catch (e) { console.log('load failed', e) }
    },
    detail(id) { this.sel_result = Object.assign({}, this.sel_result, { id : id }); console.log(id, 'item') },
  },
  created() { console.log('result.vue', 'created'); },
  destroyed() { console.log('result.vue', 'destroyed'); this.clear() },
  mounted() { console.log('result.vue', 'mounted'); this.load_site() },
}
</script>
